import { request } from 'network/request';
import store from 'store/index'
import crypto from 'crypto' //md5加密
import { MessageBox } from 'element-ui';
import requstsMethod from "common/const";
import { loginTokenResponse } from "network/loginResponse";
let deviceType = null //登录环境
let platformType = 'H5' //H5("网页");
let channelType = 'MERCHANT'
let appType = 'NATIVE' //
let isMac = /macintosh|mac os x/i.test(navigator.userAgent);
isMac ? deviceType = 'MAC' : deviceType = 'WINDOWS'
console.log(deviceType, 'isMacisMacisMac');
let sign = ""
switch (process.env.NODE_ENV) {
  case 'production':
    sign = 'rb8emaZfsWNuoUSo';
    //sign = 'EqlgPZWo';
    break
  default:
    sign = 'EqlgPZWo';
    // sign = 'rb8emaZfsWNuoUSo';
    break;
}
let constParams = {
  channelCode: "h5_api_get",
  timestamp: "123123",
  sign: sign, //测试环境
  // sign: "rb8emaZfsWNuoUSo", //正式环境
}
export async function response(Fun_Search, bizSendContent) {
  const md5 = crypto.createHash('md5');
  md5.update(constParams.channelCode + JSON.stringify(bizSendContent) + constParams.sign);
  let md5Sign = md5.digest('hex');
  return new Promise(async (resolve, reject) => {
    let reg = /^new_/;
    let result = reg.test(store.state.token);
    if (!result) {
      store.commit("toTokenLose");
    }
    request({
      url: "/api/gateway",
      method: 'post',
      data: {
        method: Fun_Search,
        channelCode: constParams.channelCode,
        timestamp: constParams.timestamp,
        bizContent: JSON.stringify(bizSendContent),
        deviceInfo: constParams.deviceInfo,
        token: store.state.token,
        sign: md5Sign,
        channelType: channelType,
        deviceType: deviceType,
        platformType: platformType,
        appType: appType,
      }
    }).then(data => {
      switch (data.code) {
        case "10000":
          if (data.bizContent) {
            resolve(JSON.parse(data.bizContent));
          } else {
            resolve(data);
          }
          break
      }
      if (data.code !== "10000") {
        console.log(data, 'dadadad');
        if (data.msg.startsWith("token验证失败")) {
          store.commit("toTokenLose");
        } else {
          MessageBox.alert(data.msg, '提示', {
            confirmButtonText: '确定',
            type: 'error'
          });
        }
      }
    }).catch(err => {
      console.log(err);
      reject(err.data)
    })
  })
}